import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import client from "@/api/client";
import { useAuth } from "@/context/AuthContext";

const PermissionsContext = createContext(null);
export const usePermissions = () => useContext(PermissionsContext);

export function PermissionsProvider({ children }) {
  const { user } = useAuth();
  const [disabled, setDisabled] = useState(null); // null = belum dimuat

  const reload = useCallback(() => {
    client.get("/menu-permissions").then((r) => setDisabled(r.data.disabled || {})).catch(() => setDisabled({}));
  }, []);

  useEffect(() => {
    if (user) reload();
    else setDisabled(null);
  }, [user, reload]);

  const loaded = disabled !== null;

  const isMenuAllowed = useCallback(
    (role, path) => {
      if (role === "super_admin") return true;
      const list = (disabled || {})[role] || [];
      return !list.includes(path);
    },
    [disabled]
  );

  const savePerms = useCallback(async (map) => {
    const { data } = await client.put("/menu-permissions", { disabled: map });
    setDisabled(data.disabled || {});
    return data.disabled || {};
  }, []);

  return (
    <PermissionsContext.Provider value={{ disabled: disabled || {}, loaded, isMenuAllowed, reload, savePerms }}>
      {children}
    </PermissionsContext.Provider>
  );
}
